import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-745b56f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column is-one-third" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Lösung", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Wert", -1))
const _hoisted_7 = { class: "is-family-monospace" }
const _hoisted_8 = { class: "is-family-monospace" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Transformation", -1))
const _hoisted_10 = { class: "is-uppercase is-family-monospace" }
const _hoisted_11 = { class: "is-uppercase is-family-monospace" }
const _hoisted_12 = { class: "is-uppercase is-family-monospace" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rätsel", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Offene Türchen", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Zeit zum nächsten Türchen", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Erstes Türchen", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Nächstes Türchen", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Letztes Türchen", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Rätsel schließt nach", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Zufalls-Seed", -1))
const _hoisted_23 = { class: "is-family-monospace" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Extra-Tage", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Leere Türchen", -1))
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "column is-one-third" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Kalender", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Definition", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Hintergrundbild", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Favicon", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Bilder", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Größe", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Rand", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Schriftarten", -1))
const _hoisted_38 = { class: "column is-one-third" }
const _hoisted_39 = { class: "content" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "WebDAV", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "URL", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Zugangsdaten", -1))
const _hoisted_43 = { class: "is-family-monospace" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag is-danger" }, "user", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag is-danger" }, "pass", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Cache-Dauer", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Konfigurationsdatei", -1))
const _hoisted_49 = { class: "content" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Sonstige", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "Redis", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "UI-Admin", -1))
const _hoisted_53 = { class: "is-family-monospace" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag is-danger" }, "user", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tag is-danger" }, "pass", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_BulmaSecret = _resolveComponent("BulmaSecret")!
  const _component_BulmaDrawer = _resolveComponent("BulmaDrawer")!

  return (_openBlock(), _createBlock(_component_BulmaDrawer, {
    header: "Konfiguration",
    onOpen: _ctx.on_open,
    refreshable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("dl", null, [
                _hoisted_6,
                _createElementVNode("dd", null, [
                  _createTextVNode(" Eingabe: "),
                  _createElementVNode("span", _hoisted_7, " \"" + _toDisplayString(_ctx.admin_config_model.solution.value) + "\" ", 1)
                ]),
                _createElementVNode("dd", null, [
                  _createTextVNode(" Ausgabe: "),
                  _createElementVNode("span", _hoisted_8, " \"" + _toDisplayString(_ctx.admin_config_model.solution.clean) + "\" ", 1)
                ]),
                _hoisted_9,
                _createElementVNode("dd", null, [
                  _createTextVNode(" Whitespace: "),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.admin_config_model.solution.whitespace), 1)
                ]),
                _createElementVNode("dd", null, [
                  _createTextVNode(" Sonderzeichen: "),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.admin_config_model.solution.special_chars), 1)
                ]),
                _createElementVNode("dd", null, [
                  _createTextVNode(" Buchstaben: "),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.admin_config_model.solution.case), 1)
                ])
              ]),
              _hoisted_13,
              _createElementVNode("dl", null, [
                _hoisted_14,
                _createElementVNode("dd", null, _toDisplayString(_ctx.store.user_doors.length), 1),
                _hoisted_15,
                (_ctx.store.next_door_target === null)
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_16, " Kein nächstes Türchen "))
                  : (_openBlock(), _createElementBlock("dd", _hoisted_17, [
                      _createVNode(_component_CountDown, {
                        until: _ctx.store.next_door_target
                      }, null, 8, ["until"])
                    ])),
                _hoisted_18,
                _createElementVNode("dd", null, _toDisplayString(_ctx.fmt_puzzle_date("first")), 1),
                _hoisted_19,
                _createElementVNode("dd", null, _toDisplayString(_ctx.fmt_puzzle_date("next")), 1),
                _hoisted_20,
                _createElementVNode("dd", null, _toDisplayString(_ctx.fmt_puzzle_date("last")), 1),
                _hoisted_21,
                _createElementVNode("dd", null, _toDisplayString(_ctx.fmt_puzzle_date("end")), 1),
                _hoisted_22,
                _createElementVNode("dd", _hoisted_23, " \"" + _toDisplayString(_ctx.admin_config_model.puzzle.seed) + "\" ", 1),
                _hoisted_24,
                _createElementVNode("dd", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admin_config_model.puzzle.extra_days, (day, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `extra_day-${index}`
                    }, [
                      (index > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(", ")
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(day), 1)
                    ]))
                  }), 128))
                ]),
                _hoisted_25,
                (_ctx.admin_config_model.puzzle.skip_empty)
                  ? (_openBlock(), _createElementBlock("dd", _hoisted_26, "Überspringen"))
                  : (_openBlock(), _createElementBlock("dd", _hoisted_27, "Anzeigen"))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("dl", null, [
                _hoisted_31,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.calendar.config_file), 1),
                _hoisted_32,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.calendar.background), 1),
                _hoisted_33,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.calendar.favicon), 1),
                _createElementVNode("dt", null, "Türchen (" + _toDisplayString(_ctx.doors.length) + " Stück)", 1),
                _createElementVNode("dd", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doors, (door, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: `door-${index}`
                    }, [
                      (index > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(", ")
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(door.day), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _hoisted_34,
              _createElementVNode("dl", null, [
                _hoisted_35,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.image.size) + " px", 1),
                _hoisted_36,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.image.border) + " px", 1),
                _hoisted_37,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admin_config_model.fonts, (font, index) => {
                  return (_openBlock(), _createElementBlock("dd", {
                    key: `font-${index}`
                  }, _toDisplayString(font.file) + " (" + _toDisplayString(font.size) + " pt) ", 1))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("dl", null, [
                _hoisted_41,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.webdav.url), 1),
                _hoisted_42,
                _createElementVNode("dd", _hoisted_43, [
                  _createVNode(_component_BulmaSecret, { onLoad: _ctx.load_dav_credentials }, {
                    default: _withCtx(() => [
                      _hoisted_44,
                      _createTextVNode(" " + _toDisplayString(_ctx.dav_credentials[0]) + " ", 1),
                      _hoisted_45,
                      _hoisted_46,
                      _createTextVNode(" " + _toDisplayString(_ctx.dav_credentials[1]), 1)
                    ]),
                    _: 1
                  }, 8, ["onLoad"])
                ]),
                _hoisted_47,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.webdav.cache_ttl) + " s", 1),
                _hoisted_48,
                _createElementVNode("dd", null, _toDisplayString(_ctx.admin_config_model.webdav.config_file), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("dl", null, [
                _hoisted_51,
                _createElementVNode("dd", null, "Host: " + _toDisplayString(_ctx.admin_config_model.redis.host), 1),
                _createElementVNode("dd", null, "Port: " + _toDisplayString(_ctx.admin_config_model.redis.port), 1),
                _createElementVNode("dd", null, "Datenbank: " + _toDisplayString(_ctx.admin_config_model.redis.db), 1),
                _createElementVNode("dd", null, "Protokoll: " + _toDisplayString(_ctx.admin_config_model.redis.protocol), 1),
                _hoisted_52,
                _createElementVNode("dd", _hoisted_53, [
                  _createVNode(_component_BulmaSecret, { onLoad: _ctx.load_ui_credentials }, {
                    default: _withCtx(() => [
                      _hoisted_54,
                      _createTextVNode(" " + _toDisplayString(_ctx.ui_credentials[0]) + " ", 1),
                      _hoisted_55,
                      _hoisted_56,
                      _createTextVNode(" " + _toDisplayString(_ctx.ui_credentials[1]), 1)
                    ]),
                    _: 1
                  }, 8, ["onLoad"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOpen"]))
}